import React, { useRef, useState } from 'react';
import { v4 as uuid } from 'uuid';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Typo, Tooltip, Icon, Spinner, Media } from '@ers/ui';
import { Variants } from '@ers/ui/Typo';
import { useSelectorWithDispatch } from '@ers/hooks/';
import { StateManagerProps } from '../Offer';
import { getOfferFile } from '../offer.selectors';
import { fetchJobOfferLinkFile } from '../offer.actions';

const Image = ({ src }) => {
    const ref = useRef(null);
    const [className, setClassName] = useState('img__square');
    const handleLoad = () => {
        const { current: { clientWidth, clientHeight } } = ref;
        if (clientWidth > clientHeight) {
            setClassName('img__horizontal');
        }
        if (clientWidth < clientHeight) {
            setClassName('img__vertical');
        }
    };
    return (
        <img
            ref={ref}
            className={cx('img', className)}
            alt="opengraph logo"
            src={src}
            onLoad={handleLoad}
        />
    );
};
Image.propTypes = {
    src: PropTypes.string.isRequired
};
const OfferPreview = ({ nextState, offer, applicationId }) => {
    const { image, jobOfferUrl, title, description } = offer;
    const displayURL = title ? new URL(jobOfferUrl).host : jobOfferUrl;
    const { fileId } = image && image.imageFile || {};
    const file = fileId
        ? useSelectorWithDispatch(
            (state) => getOfferFile(state, { applicationId, fileId }),
            () => fetchJobOfferLinkFile(applicationId, fileId),
            (f) => !f
        )
        : null;
    return (
        <>
            <Tooltip tip="Usuń" id={uuid()}>
                <Icon name="bin" hover onClick={nextState} />
            </Tooltip>
            <a href={jobOfferUrl} target="_blank" rel="noopener noreferrer">
                <div className="offerlink">
                    {fileId ? (
                        file ? (
                            <div className="offerlink_image">
                                <Image src={file} />
                            </div>
                        ) : (
                            <Spinner />
                        )
                    ) : (
                        <Icon name="briefcase" big />
                    )}
                    <div
                        className={cx('offerlink_desc with-margin--left-3', {
                            'offerlink--center': !title
                        })}
                    >
                        {title ? (
                            <>
                                <div>
                                    <Typo.Subheader
                                        className="offerlink_title"
                                        dangerouslySetInnerHTML={{
                                            __html: title
                                        }}
                                    />
                                    <Media
                                        fullHD
                                        desktop
                                        tabletLandscape
                                        tabletPortrait
                                    >
                                        <Typo.Body
                                            className="with-margin--top-1"
                                            dangerouslySetInnerHTML={{
                                                __html: description
                                            }}
                                        />
                                    </Media>
                                </div>
                                <Typo.Body
                                    className="with-margin--top-1"
                                    variant={Variants.LIGHT}
                                >
                                    {displayURL}
                                </Typo.Body>
                            </>
                        ) : (
                            <Typo.Body variant={Variants.LINK}>
                                {displayURL}
                            </Typo.Body>
                        )}
                    </div>
                </div>
            </a>
        </>
    );
};

OfferPreview.propTypes = StateManagerProps;
export default OfferPreview;
